import styled from "styled-components";
import { FenaLogo } from "../../../components/icons";
import { Typography, TypographyVariant } from "../../../components/ui-kit";

const Wrapper = styled.div``;

const Header = styled.div`
  padding: 30px;
`;

const Content = styled.div`
  display: flex;
  height: calc(100vh - 89.44px);
  flex-direction: column;
  align-items: center;
  padding: 0 calc((100vw - 1000px) / 2);
`;

const Label = styled(Typography)`
  margin-top: 5rem;
`;

const Caption = styled(Typography)`
  margin-top: 15px;
  text-align: center;
`;

const Link = styled.a`
  color: #027aff;
  text-decoration: none;
`;

const QuickbooksDisconnect: React.FunctionComponent = () => {
  return (
    <Wrapper>
      <Header>
        <FenaLogo />
      </Header>
      <Content>
        <Label variant={TypographyVariant.HEADER1}>
          QuickBooks Disconnected
        </Label>
        <Caption variant={TypographyVariant.BODY1}>
          Your QuickBooks integration has been disconnected. You will no longer
          to be able to create Fena payment links for your QuickBooks invoices.
          If you’d like to re-connect Fena and your QuickBooks account,
          visit&nbsp;
          <Link
            href="https://help.fena.co/support/solutions/articles/101000503069-how-to-connect-quickbooks"
            target="_blank"
          >
            our help guide
          </Link>
          . For general Fena support contact us at&nbsp;
          <Link
            href={`mailto:support@fena.co?subject&body=${encodeURIComponent(
              "QuickBooks disconnect help"
            )}`}
          >
            support@fena.co
          </Link>
        </Caption>
      </Content>
    </Wrapper>
  );
};

export default QuickbooksDisconnect;
